module.exports = __webpack_public_path__ + "media/30.67453d8b.mp3";